import axiosInstance from '../functions/axiosInstance';
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const getCodeSystemsAndValueSetsList = async (apiToken = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    console.log("CALLING SERVER with getcodesystemsandvaluesetslist")
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'getcodesystemsandvaluesetslist',
            'apiToken': apiToken
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from getcodesystemsandvaluesetslist call");
    }).catch((error) => { console.log(error); });
}

export default getCodeSystemsAndValueSetsList;